var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejecticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.5 0 0 22.5 0 50C0 77.5 22.5 100 50 100C77.5 100 100 77.5 100 50C100 22.5 77.5 0 50 0ZM68.5 61.5C70.5 63.5 70.5 66.5 68.5 68.5C66.5 70.5 63.5 70.5 61.5 68.5L50 57L38.5 68.5C36.5 70.5 33.5 70.5 31.5 68.5C29.5 66.5 29.5 63.5 31.5 61.5L43 50L31.5 38.5C29.5 36.5 29.5 33.5 31.5 31.5C33.5 29.5 36.5 29.5 38.5 31.5L50 43L61.5 31.5C63.5 29.5 66.5 29.5 68.5 31.5C70.5 33.5 70.5 36.5 68.5 38.5L57 50L68.5 61.5Z",
    fill: "#FB5012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejecticon);
export default __webpack_public_path__ + "static/media/Rejecticon.4c3692c78c891ee32221d0fdd08692a7.svg";
export { ForwardRef as ReactComponent };